import './App.css';

function Settings() {
    return (
    <div className="Settings">
        <div className='flex-container'>
            <h1>Settings</h1>


        </div>
    </div>
  );
}

export default Settings;
